declare var CVVALIDATION: any;
declare var showConfirmDialog: any;

import { Injectable } from '@angular/core';
import { CVApiService } from 'src/app/reusables/services/cv-api.service';
import { BaseGroupType } from '../../../../../AngularJS/Models/group-type.model';
import { CVLocalizationService } from "src/app/reusables/services/cv-localization.service";
import { GroupSelectorDTO, GroupSelectorPostObject } from '../../../../../AngularJS/Reusables/group-selector.models';
import { PointStoreProductFilterService } from '../../admin/services/point-store-product-filter.service';
import moment from 'moment';
import { CvConfigurationService } from 'src/app/reusables/services/cv-configuration.service';

@Injectable({
  providedIn: 'root'
})
export class PointStoreProductOrderService {
  isCxOne : boolean = false;
  pointStoreProductOrderObj: any = {
    adminOrders: null,
    groupHeaderInfo: null,
    historyOrders: null,
    originalPointStoreProductOrder: null,
    modifiedPointStoreProductOrder: null,
    sortBy: "DateOrdered",
    sortReverse: true,
    loadingTable: false,
    loadingProductsInfo: false,
    firstLoadedTime: false,
    isloadingExternalFilter: false,
    opc: '',
    OrderStatus: [
      { value: 1, name: "Processing", keyLocalization: 'Processing' },
      { value: 2, name: "In transit", keyLocalization: 'Intransit' },
      { value: 6, name: "Shipped", keyLocalization: 'Shipped' },
      { value: 3, name: "Ready for pick-up", keyLocalization: 'Ready_For_Pickup' },
      { value: 4, name: "Complete", keyLocalization: 'Completed' },
      { value: 5, name: "Cancelled", keyLocalization: 'Cancelled' },
    ],
    sortAdminBy: "DateOrdered",
    sortAdminReverse: true,
    pointStoreProductOrderAdminSort: [
      { value: 0, sort: null, name: 'PointStoreOrderID' },
      { value: 1, sort: null, name: 'LoginName' },
      { value: 2, sort: null, name: 'DateOrdered' },
      { value: 3, sort: null, name: 'OrderTotal' },
      { value: 4, sort: null, name: 'OrderStatus' },
      { value: 5, sort: null, name: 'Note' },
      { value: 6, sort: null, name: 'ParentGroup' }
    ],
    pointStoreProductOrderSort: [
      { value: 0, sort: null, name: 'PointStoreOrderID' },
      { value: 1, sort: null, name: 'DateOrdered' },
      { value: 2, sort: null, name: 'OrderTotal' },
      { value: 3, sort: null, name: 'OrderStatus' },
      { value: 4, sort: null, name: 'Note' }
    ],
    pointStoreProductOrdersCSS: [
      { value: 0, name: "pointStoreImage carousel-product-sale-thumbnail active" },
      { value: 1, name: "pointStoreImage carousel-product-thumbnail active" },
      { value: 2, name: "pointStoreImage carousel-thumbnail active" },
      { value: 3, name: "pointStoreImage carousel-sale-thumbnail active" },
      { value: 4, name: "pointStoreImage product-sale-thumbnail active" },
      { value: 5, name: "pointStoreImage product-thumbnail active" },
      { value: 6, name: "pointStoreImage sale-thumbnail active" },
      { value: 7, name: "pointStoreImage carousel-product-thumbnail inactive" },
      { value: 8, name: "pointStoreImage sale-thumbnail inactive" },
      { value: 9, name: "pointStoreImage sort-double-arrow-icon sortable-double-arrow" },
      { value: 10, name: "pointStoreImage sort-arrow-up-icon" },
      { value: 11, name: "pointStoreImage sort-arrow-down-icon" },
      { value: 12, name: "" }, //A default value for the sort arrows.
      { value: 13, name: "sgSelectUpArrow sgHideDownArrow" },
      { value: 14, name: "sgSelectDownArrow sgHideUpArrow" },
    ],
    pointStoreProductMessages: [
      { value: 0, name: "warning", keyLocalization: "Warning" },
      { value: 1, name: "Point Store Order Management Validation Warning", keyLocalization: "Order_Management_Validation_Warning" },
      { value: 2, name: "If you change the status to complete, you can not undo it, Continue anyway?", keyLocalization: "Change_Status_Complete" },
      { value: 3, name: "Yes", keyLocalization: "Yes" },
      { value: 4, name: "No", keyLocalization: "No" },
      { value: 5, name: "If you change the status to cancelled, you can not undo it, Continue anyway?", keyLocalization: "Change_Status_Cancelled" },
    ],
    clickEdited: false,
    pointStoreProductAdminOrderFilter: this.pointStoreProductFilterService.getNewAdminOrderFilter(),
    isUpdating: false,
    isLoaded: false,
    pointStoreProductAgentOrderFilter: { searchOrder: '', },
    validateCompleteFlag: null,
    validateCompleteFlagResult: null,
    validateCancelledFlag: null,
    validateCancelledFlagResult: null,
    settingPointStoreProductOrder: null,
    groupSelectorController: '',
    hasGroupSelector: false,
    dataFiltered: [],
    MSTOffset: 0,
    ordersLoading:false,
  }

  constructor(
    private cvLocalizationService: CVLocalizationService,
    private cvApiService: CVApiService,
    private pointStoreProductFilterService: PointStoreProductFilterService,
    public cvConfigurationService: CvConfigurationService,
  ) {
    this.isCxOne = this.cvConfigurationService.isCxOne;
   }

  async loadOrderStatusName() {
    try {
      let response = await this.cvLocalizationService.GetSection('MarketPlace_Management_Status');
      for (let i = 0; i < this.pointStoreProductOrderObj.OrderStatus.length; i++) {
        if (this.pointStoreProductOrderObj.OrderStatus[i].name === "Complete") {
          this.pointStoreProductOrderObj.OrderStatus[i].name = response.get(this.isCxOne ? "Completed" : this.pointStoreProductOrderObj.OrderStatus[i].keyLocalization);
        } 
        
        if (this.pointStoreProductOrderObj.OrderStatus[i].name === "Ready for pick-up") {
          this.pointStoreProductOrderObj.OrderStatus[i].name = response.get(this.isCxOne ? "Ready_for_Pickup_No_Dash" : this.pointStoreProductOrderObj.OrderStatus[i].keyLocalization);
        } 
        this.pointStoreProductOrderObj.OrderStatus[i].name = response.get(this.pointStoreProductOrderObj.OrderStatus[i].keyLocalization);
      }
    } catch (error) {
      showErrorMessage(error.message);
    }
  }

  async loadPointStoreProductAdminOrder(isCxOne = false) {
    try {
        const url = `/api/v2/marketplace/admin/orders/${isCxOne ? 'cxone' : ''}`;
        let response = await this.cvApiService.get(url);
        if (response.status_code == 200) {
            return response.data;
        } else {
            throw response;
        }
    } catch (error) {
        showErrorMessage("Error Loading Point Store Product Orders: " + error.message);
    }
}

  async savePointStoreProductAdminOrder(order) {
    try {
      const url = "/api/v2/marketplace/orders/save";
      const params = {
        originalList: this.pointStoreProductOrderObj.originalPointStoreProductOrder.ProductsCollection,
        modifyList: order.ProductsCollection,
        modifiedPointStoreOrder: order
      }
      let response = await this.cvApiService.post(url, params);
      if (response.status_code == 200) {
        return response.data;
      }
      else {
        throw response;
      }
    } catch (error) {
      showErrorMessage("Error Saving Point Store Product Order: " + error.message);
    }
  }

  async loadPointStoreProduct() {
    try {
      this.pointStoreProductOrderObj.loadingProductsInfo = true;
      const url = "/api/v2/marketplace/admin/products/";
      let response = await this.cvApiService.get(url);
      if (response.status_code == 200) {
        this.pointStoreProductOrderObj.loadingProductsInfo = false;
        return response.data;
      }
      else {
        throw response;
      }
    } catch (error) {
      showErrorMessage("Error Loading Point Store Products: " + error.message);
    }
  }

  validateChangeStatusComplete() {
    return new Promise(async (resolve, reject) => {
      let validation = new CVVALIDATION.ValidationInstance();
      validation.succeeded = false;
      validation.addValidationError(await this.cvLocalizationService.GetLocalText("MarketPlace_Management_Messages", "Change_Status_Complete", "If you change the status to complete, you can not undo it, Continue anyway?"), true);

      new showConfirmDialog("<ul class='errorBulletList'>" + validation.messagesToListItemsString() + "</ul>",
        [
          {
            text: await this.cvLocalizationService.GetLocalText("Common", "Yes", "Yes"),
            click: function () {
              let msg: any = $(".errorDialog");
              msg.dialog("close");
              //return true;
              resolve(true);
            }
          },
          {
            text: await this.cvLocalizationService.GetLocalText("Common", "No", "No"),
            click: function () {
              let msg: any = $(".errorDialog");
              msg.dialog("close");
              //return false;
              resolve(false);
            }
          }
        ], await this.cvLocalizationService.GetLocalText("MarketPlace_Management_Messages", "Order_Management_Validation_Warning", "Point Store Order Management Validation Warning"), 'warning');
    });
  }

  async LoadPointStoreProductAdminOrders(isCxOne = false) {
    // Prevent multiple simultaneous calls when executing one at a time
    if (this.pointStoreProductOrderObj.isLoading) {
        return;
    }

    this.pointStoreProductOrderObj.isLoading = true; // Set loading flag

    try {
        this.pointStoreProductOrderObj.ordersLoading = true;
        if (this.pointStoreProductOrderObj.firstLoadedTime) {
            this.pointStoreProductOrderObj.loadingTable = true;
        }
        this.pointStoreProductOrderObj.firstLoadedTime = true;

        const adminOrderRes: any = await this.loadPointStoreProductAdminOrder(isCxOne);
        const filterMatchesEmpGroup = isCxOne ? this.setFilterMatchesEmpGroupCXOne.bind(this) : this.setFilterMatchesEmpGroup.bind(this);

        if (adminOrderRes) {
            this.pointStoreProductOrderObj.isLoaded = true;
            this.pointStoreProductOrderObj.MSTOffset = adminOrderRes.MSTOffset;
            this.pointStoreProductOrderObj.groupHeaderInfo = adminOrderRes.HeadersColumnsNames;
            this.pointStoreProductOrderObj.adminOrders = [];
            this.pointStoreProductOrderObj.loadingTable = false;

            adminOrderRes.Products.forEach((item) => {
                if (filterMatchesEmpGroup(item)) {
                    this.pointStoreProductOrderObj.adminOrders.push(item);
                }
            });

            this.pointStoreProductOrderObj.isloadingExternalFilter = false;
        }

        this.pointStoreProductOrderObj.ordersLoading = false;
    } catch (error) {
        console.error('Error loading admin orders:', error);
    } finally {
        // Ensure the flag is always reset, even if an error occurs
        this.pointStoreProductOrderObj.isLoading = false;
    }

}
  /**
   * 
   * @param item 
   * @returns 
   */
  setFilterMatchesEmpGroup(item) {
    let match_groupSelector = false;
    let groupLevelSelected = 0;
    let firstLevelNonZero = -1;
    let flagForFirstLevel = false;
    let GroupSelectorIDs = Array.isArray(this.pointStoreProductOrderObj.pointStoreProductAdminOrderFilter.gIDs) ? this.pointStoreProductOrderObj.pointStoreProductAdminOrderFilter.gIDs : Array.from(this.pointStoreProductOrderObj.pointStoreProductAdminOrderFilter.gIDs);
    var glvl = parseInt(this.pointStoreProductOrderObj.pointStoreProductAdminOrderFilter.gLvl)
    if (GroupSelectorIDs.length > 0 && GroupSelectorIDs[0] == -1) { // -1 means current group, this data is already filtered
      return true;
    }

    if (this.pointStoreProductOrderObj.pointStoreProductAdminOrderFilter.empGroup != undefined) {
      for (let i = 1; i <= this.pointStoreProductOrderObj.pointStoreProductAdminOrderFilter.empGroup.length - 1; i++) {
        if (parseInt(this.pointStoreProductOrderObj.pointStoreProductAdminOrderFilter.empGroup[i][0])) {
          if (parseInt(this.pointStoreProductOrderObj.pointStoreProductAdminOrderFilter.empGroup[i][0]) > 0 && !flagForFirstLevel) {
            flagForFirstLevel = true;
            firstLevelNonZero = i;
          }
        }
      };
      for (let i = this.pointStoreProductOrderObj.pointStoreProductAdminOrderFilter.empGroup.length - 1; i > 0; i--) {
        if (this.pointStoreProductOrderObj.pointStoreProductAdminOrderFilter.empGroup[i][0] != -1)
          groupLevelSelected = i;
      }
    }

    //There are other filter.
    //if there was a level with a non zero value (group selected), then use that level
    var finalVariable = firstLevelNonZero != -1 ? firstLevelNonZero : groupLevelSelected;

    //RelatedGroupLevel is the buyer's own level, so an order belongs to the viewed level when its
    //owner sits at that level or below it. Requiring equality hid everything below the viewed level.
    const matchesGroupLevel: boolean = item.RelatedGroupLevel <= groupLevelSelected;

    switch (finalVariable) {
      //cases 0/1 keep the literal == 1: finalVariable can be 0, where matchesGroupLevel is never true
      case 0:
      case 1: match_groupSelector = (item.RelatedGroupLevel == 1 && (this.pointStoreProductOrderObj.pointStoreProductAdminOrderFilter.empGroup[1][0] == 0 || this.pointStoreProductOrderObj.pointStoreProductAdminOrderFilter.empGroup[1].filter(function (value) { return parseInt(value) == item.Group1ID }).length > 0)); break;
      case 2:
        match_groupSelector =
          ((firstLevelNonZero == -1 && this.pointStoreProductOrderObj.pointStoreProductAdminOrderFilter.empGroup[2][0] == 0)
            || this.pointStoreProductOrderObj.pointStoreProductAdminOrderFilter.empGroup[2].filter(function (value) { return parseInt(value) == item.Group2ID }).length > 0)
          && (this.pointStoreProductOrderObj.pointStoreProductAdminOrderFilter.empGroup[1][0] == 0
            || (this.pointStoreProductOrderObj.pointStoreProductAdminOrderFilter.empGroup[1].filter(function (value) { return parseInt(value) == item.Group1ID }).length > 0)
            || this.pointStoreProductOrderObj.pointStoreProductAdminOrderFilter.empGroup[1][0] == -1)
          && matchesGroupLevel;
        break;
      case 3:
        match_groupSelector = ((firstLevelNonZero == -1 && this.pointStoreProductOrderObj.pointStoreProductAdminOrderFilter.empGroup[3][0] == 0) || this.pointStoreProductOrderObj.pointStoreProductAdminOrderFilter.empGroup[3].filter(function (value) { return parseInt(value) == item.Group3ID }).length > 0)
          && ((this.pointStoreProductOrderObj.pointStoreProductAdminOrderFilter.empGroup[2][0] == 0) || (this.pointStoreProductOrderObj.pointStoreProductAdminOrderFilter.empGroup[2].filter(function (value) { return parseInt(value) == item.Group2ID }).length > 0) || this.pointStoreProductOrderObj.pointStoreProductAdminOrderFilter.empGroup[2][0] == -1)
          && ((this.pointStoreProductOrderObj.pointStoreProductAdminOrderFilter.empGroup[1][0] == 0) || (this.pointStoreProductOrderObj.pointStoreProductAdminOrderFilter.empGroup[1].filter(function (value) { return parseInt(value) == item.Group1ID }).length > 0) || this.pointStoreProductOrderObj.pointStoreProductAdminOrderFilter.empGroup[1][0] == -1)
          && matchesGroupLevel;
        break;
      case 4:
        match_groupSelector = ((firstLevelNonZero == -1 && this.pointStoreProductOrderObj.pointStoreProductAdminOrderFilter.empGroup[4][0] == 0) || this.pointStoreProductOrderObj.pointStoreProductAdminOrderFilter.empGroup[4].filter(function (value) { return parseInt(value) == item.Group4ID }).length > 0)
          && ((this.pointStoreProductOrderObj.pointStoreProductAdminOrderFilter.empGroup[3][0] == 0) || (this.pointStoreProductOrderObj.pointStoreProductAdminOrderFilter.empGroup[3].filter(function (value) { return parseInt(value) == item.Group3ID }).length > 0) || this.pointStoreProductOrderObj.pointStoreProductAdminOrderFilter.empGroup[3][0] == -1)
          && ((this.pointStoreProductOrderObj.pointStoreProductAdminOrderFilter.empGroup[2][0] == 0) || (this.pointStoreProductOrderObj.pointStoreProductAdminOrderFilter.empGroup[2].filter(function (value) { return parseInt(value) == item.Group2ID }).length > 0) || this.pointStoreProductOrderObj.pointStoreProductAdminOrderFilter.empGroup[2][0] == -1)
          && ((this.pointStoreProductOrderObj.pointStoreProductAdminOrderFilter.empGroup[1][0] == 0) || (this.pointStoreProductOrderObj.pointStoreProductAdminOrderFilter.empGroup[1].filter(function (value) { return parseInt(value) == item.Group1ID }).length > 0) || this.pointStoreProductOrderObj.pointStoreProductAdminOrderFilter.empGroup[1][0] == -1)
          && matchesGroupLevel;
        break;
      case 5:
        match_groupSelector = ((firstLevelNonZero == -1 && this.pointStoreProductOrderObj.pointStoreProductAdminOrderFilter.empGroup[5][0] == 0) || this.pointStoreProductOrderObj.pointStoreProductAdminOrderFilter.empGroup[5].filter(function (value) { return parseInt(value) == item.Group5ID }).length > 0)
          && ((this.pointStoreProductOrderObj.pointStoreProductAdminOrderFilter.empGroup[4][0] == 0) || (this.pointStoreProductOrderObj.pointStoreProductAdminOrderFilter.empGroup[4].filter(function (value) { return parseInt(value) == item.Group4ID }).length > 0) || this.pointStoreProductOrderObj.pointStoreProductAdminOrderFilter.empGroup[4][0] == -1)
          && ((this.pointStoreProductOrderObj.pointStoreProductAdminOrderFilter.empGroup[3][0] == 0) || (this.pointStoreProductOrderObj.pointStoreProductAdminOrderFilter.empGroup[3].filter(function (value) { return parseInt(value) == item.Group3ID }).length > 0) || this.pointStoreProductOrderObj.pointStoreProductAdminOrderFilter.empGroup[3][0] == -1)
          && ((this.pointStoreProductOrderObj.pointStoreProductAdminOrderFilter.empGroup[2][0] == 0) || (this.pointStoreProductOrderObj.pointStoreProductAdminOrderFilter.empGroup[2].filter(function (value) { return parseInt(value) == item.Group2ID }).length > 0) || this.pointStoreProductOrderObj.pointStoreProductAdminOrderFilter.empGroup[2][0] == -1)
          && ((this.pointStoreProductOrderObj.pointStoreProductAdminOrderFilter.empGroup[1][0] == 0) || (this.pointStoreProductOrderObj.pointStoreProductAdminOrderFilter.empGroup[1].filter(function (value) { return parseInt(value) == item.Group1ID }).length > 0) || this.pointStoreProductOrderObj.pointStoreProductAdminOrderFilter.empGroup[1][0] == -1)
          && matchesGroupLevel;
        break;
    }
    //Group selector check
    //RelatedGroupID
    //RelatedGroupLevel
    /*if (!this.pointStoreProductOrderObj.pointStoreProductAdminOrderFilter.gIDs || this.pointStoreProductOrderObj.pointStoreProductAdminOrderFilter.gIDs == 0) {
        match_groupSelector = true;
    } else
    //if (item.RelatedGroupID == this.pointStoreProductOrderObj.pointStoreProductAdminOrderFilter.gIDs && item.RelatedGroupLevel == this.pointStoreProductOrderObj.pointStoreProductAdminOrderFilter.gLvl)
    {
        var GroupSelectorIDs = Array.isArray(this.pointStoreProductOrderObj.pointStoreProductAdminOrderFilter.gIDs) ? this.pointStoreProductOrderObj.pointStoreProductAdminOrderFilter.gIDs : Array.from(this.pointStoreProductOrderObj.pointStoreProductAdminOrderFilter.gIDs);
        switch (parseInt(this.pointStoreProductOrderObj.pointStoreProductAdminOrderFilter.gLvl)) {
            case 0:
            case 1: match_groupSelector = (GroupSelectorIDs.filter(function (value) { return parseInt(value) == item.Group1ID }).length > 0); break;
            case 2: match_groupSelector = (GroupSelectorIDs.filter(function (value) { return parseInt(value) == item.Group2ID }).length > 0); break;
            case 3: match_groupSelector = (GroupSelectorIDs.filter(function (value) { return parseInt(value) == item.Group3ID }).length > 0); break;
            case 4: match_groupSelector = (GroupSelectorIDs.filter(function (value) { return parseInt(value) == item.Group4ID }).length > 0); break;
            case 5: match_groupSelector = (GroupSelectorIDs.filter(function (value) { return parseInt(value) == item.Group5ID }).length > 0); break;
        }
        //match_groupSelector = true;
    }*/

    return match_groupSelector;

  }

  async loadMessages() {

  }

  async LoadPointStoreProductHistoryOrders() {
    try {
      const url = "/api/v2/marketplace/orders/";
      let response = await this.cvApiService.get(url);
      if (response.status_code == 200) {
        this.pointStoreProductOrderObj.isLoaded = true;
        this.pointStoreProductOrderObj.historyOrders = response.data;
        this.pointStoreProductOrderObj.isUpdating = false;
        return response.data;
      }
      else {
        throw response;
      }
    } catch (error) {
      showErrorMessage("Error Loading Point Store Product Order by LoginID: " + error.message);
    }
  }

  getOrderStatusName(orderStatusID) {
    for (let i = 0; i < this.pointStoreProductOrderObj.OrderStatus.length; i++) {
      if (this.pointStoreProductOrderObj.OrderStatus[i].value == orderStatusID) {
        return this.pointStoreProductOrderObj.OrderStatus[i].name;
      }
    }
  };

  copyModifiedToOriginal() {
    this.pointStoreProductOrderObj.originalPointStoreProductOrder = angular.copy(this.pointStoreProductOrderObj.modifiedPointStoreProductOrder);

    for (let i = 0; i < this.pointStoreProductOrderObj.adminOrders.length; i++) {
      if (this.pointStoreProductOrderObj.adminOrders[i].PointStoreOrderID == this.pointStoreProductOrderObj.originalPointStoreProductOrder.PointStoreOrderID) {
        this.pointStoreProductOrderObj.adminOrders[i].Note = angular.copy(this.pointStoreProductOrderObj.originalPointStoreProductOrder.Note)
        this.pointStoreProductOrderObj.adminOrders[i].ProductsCollection = angular.copy(this.pointStoreProductOrderObj.originalPointStoreProductOrder.ProductsCollection)
      }
    }
    this.pointStoreProductOrderObj.modifiedPointStoreProductOrder = null;
  };

  EditPointStoreProductAdminOrderManagement(order, isCxOne = false) {
    order['Note'] = order['Note'] ?? "";
    this.savePointStoreProductAdminOrder(order).then(
      async (result) => {
        let productsCollection = result['ProductsCollection'];
        if (productsCollection) {
          const modifiedProductsCollectionQuantity = productsCollection.length / 2;
          productsCollection.splice(0, modifiedProductsCollectionQuantity);
        }

        this.pointStoreProductOrderObj.modifiedPointStoreProductOrder = angular.copy(result);
        this.copyModifiedToOriginal();
        //pointStoreProductEditFactory.setUpgLoad(false);
        order = angular.copy(result);
        this.pointStoreProductOrderObj.isloadingExternalFilter = true;
        if (!isCxOne) {
          await this.LoadPointStoreProductAdminOrders();
        }
      }
    );
  };

  clickClose(order) {
    //Reset order-specific editables
    order.OrderStatus = this.pointStoreProductOrderObj.originalPointStoreProductOrder.OrderStatus;
    order.Note = this.pointStoreProductOrderObj.originalPointStoreProductOrder.Note;

    //Reset the status for each item in the order
    for (let i = 0; i < order.ProductsCollection.length; i++) {
      order.ProductsCollection[i]._PointStoreProductOrderedDTO.ProductStatus = this.pointStoreProductOrderObj.originalPointStoreProductOrder.ProductsCollection[i]._PointStoreProductOrderedDTO.ProductStatus
    }

    //Close the Details+Edit expanded view.
    order.clickExpanded = false;
    order.clickEdited = false;
  };

  async EditPointStoreProductAdminOrder(order) {
    //Check the order (whole order and all ordered products) status.
    //  If Complete status (whole order and any child), show Complete status verify popup.
    //  If not Complete, check for Cancelled Status, show Cancelled status verify popup
    //  Otherwise, just update the order with no popup.
    if (order.OrderStatus == 4 && order.OrderStatus != this.pointStoreProductOrderObj.originalPointStoreProductOrder.OrderStatus) { // Complete
      //If checked, run the matching action
      if (this.pointStoreProductOrderObj.validateCompleteFlag) {
        if (this.pointStoreProductOrderObj.validateCompleteFlagResult) {
          // Don't modify cancelled products if the user is completing the whole order
          for (let i = 0; i < order.ProductsCollection.length; i++) {
            if (this.pointStoreProductOrderObj.originalPointStoreProductOrder.ProductsCollection[i]._PointStoreProductOrderedDTO.ProductStatus === 5)
              order.ProductsCollection[i]._PointStoreProductOrderedDTO.ProductStatus = this.pointStoreProductOrderObj.originalPointStoreProductOrder.ProductsCollection[i]._PointStoreProductOrderedDTO.ProductStatus;
          }
          this.EditPointStoreProductAdminOrderManagement(order);
        } else
          this.clickClose(order);
      }

      //Check for Cancelled status (whole order and any child)
    } else if (order.OrderStatus == 5 && order.OrderStatus != this.pointStoreProductOrderObj.originalPointStoreProductOrder.OrderStatus) { // Cancelled
      //If checked, run the matching action
      if (this.pointStoreProductOrderObj.validateCancelledFlag) {
        if (this.pointStoreProductOrderObj.validateCancelledFlagResult)
          this.EditPointStoreProductAdminOrderManagement(order);
        else
          this.clickClose(order);
      }

    } else {
      // Check each product in the order, verify if it is marked as Completed or Cancelled.
      let isCompleteChild = false;
      let isCancelledChild = false;
      let isUnauthorized = false;
      let productsChangedCount = 0;
      let hasCompleteCancelledItems = false;
      let originalProductStatus;

      for (let i = 0; i < order.ProductsCollection.length; i++) {
        originalProductStatus = this.pointStoreProductOrderObj.originalPointStoreProductOrder.ProductsCollection[i]._PointStoreProductOrderedDTO.ProductStatus;

        if (order.ProductsCollection[i]._PointStoreProductOrderedDTO.ProductStatus != originalProductStatus) {
          productsChangedCount++;
          if (originalProductStatus === 4 || originalProductStatus === 5) {
            // Prevent cancelled or complete status change
            order.ProductsCollection[i]._PointStoreProductOrderedDTO.ProductStatus = originalProductStatus;
            hasCompleteCancelledItems = true;
          }
        }

        //Check if the user is trying to change status to Complete/Cancelled
        if (order.ProductsCollection[i]._PointStoreProductOrderedDTO.ProductStatus === 4 && order.ProductsCollection[i]._PointStoreProductOrderedDTO.ProductStatus != originalProductStatus) {
          isCompleteChild = true;
        } else if (order.ProductsCollection[i]._PointStoreProductOrderedDTO.ProductStatus === 5 && order.ProductsCollection[i]._PointStoreProductOrderedDTO.ProductStatus != originalProductStatus) {
          isCancelledChild = true;
        }
      }

      //The user is trying to change a single completed/cancelled product
      if (productsChangedCount === 1 && hasCompleteCancelledItems) {
        new showConfirmDialog(await this.cvLocalizationService.GetLocalText("MarketPlace_Management_Messages", "You_Cannot_Change_The_Status", "You cannot change the status from complete or cancelled status"),
            [
              {
                text: "OK",
                click: function () {
                  let msg: any = $(".errorDialog");
                  msg.dialog("close");
                }
              }
            ], await this.cvLocalizationService.GetLocalText("MarketPlace_Management_Messages", "Order_Management_Validation_Warning", "MarketPlace Order Management Validation Warning"), "warning");
          this.pointStoreProductOrderObj.isloadingExternalFilter = true;
          await this.LoadPointStoreProductAdminOrders();
          isUnauthorized = true;
      }



      if (!isUnauthorized) {
        if (isCompleteChild) {
          this.validateChangeStatusComplete().then(
            async (result: any) => {
              if (result)
                this.EditPointStoreProductAdminOrderManagement(order)
              else {
                this.clickClose(order);
                this.pointStoreProductOrderObj.isloadingExternalFilter = true;
                await this.LoadPointStoreProductAdminOrders();
              }
            }
          );
        } else if (isCancelledChild) {
          this.validateChangeStatusCancelled().then(
            async(result: any) => {
              if (result)
                this.EditPointStoreProductAdminOrderManagement(order)
              else {
                this.clickClose(order);
                this.pointStoreProductOrderObj.isloadingExternalFilter = true;
                await this.LoadPointStoreProductAdminOrders();
              }
            }
          );
        } 
        else {
          await this.EditPointStoreProductAdminOrderManagement(order);
        }
      }
    }


  };

  async EditPointStoreProductAdminOrderCxOne(order) {
    const { OrderStatus, ProductsCollection } = order;
    const { originalPointStoreProductOrder, validateCompleteFlag, validateCompleteFlagResult, validateCancelledFlag, validateCancelledFlagResult } = this.pointStoreProductOrderObj;
    const checkProductStatus = async(product, originalProduct) => {
        const { ProductStatus } = product._PointStoreProductOrderedDTO;
        const originalProductStatus = originalProduct._PointStoreProductOrderedDTO.ProductStatus;
        if (ProductStatus !== originalProductStatus && (originalProductStatus === 4 || originalProductStatus === 5)) {
            this.pointStoreProductOrderObj.isloadingExternalFilter = true;
            await this.LoadPointStoreProductAdminOrders(true);
            return true;
        }
        return ProductStatus === 4 || ProductStatus === 5;
    };

    if (OrderStatus === 4 && OrderStatus !== originalPointStoreProductOrder.OrderStatus) { // Complete
        if (validateCompleteFlag) {
            if (validateCompleteFlagResult) {
                ProductsCollection.forEach((product, i) => {
                    if (originalPointStoreProductOrder.ProductsCollection[i]._PointStoreProductOrderedDTO.ProductStatus === 5)
                        product._PointStoreProductOrderedDTO.ProductStatus = originalPointStoreProductOrder.ProductsCollection[i]._PointStoreProductOrderedDTO.ProductStatus;
                });
                this.EditPointStoreProductAdminOrderManagement(order, true);
            } else {
                this.clickClose(order);
            }
        }
    } else if (OrderStatus === 5 && OrderStatus !== originalPointStoreProductOrder.OrderStatus) { // Cancelled
        if (validateCancelledFlag) {
            if (validateCancelledFlagResult) {
                this.EditPointStoreProductAdminOrderManagement(order, true);
            } else {
                this.clickClose(order);
            }
        }
    } else {
        let isUnauthorized = false;
        let isCompleteChild = false;
        let isCancelledChild = false;

        ProductsCollection.forEach(async (product, i) => {
            const originalProduct = originalPointStoreProductOrder.ProductsCollection[i];
            const isUnauthorizedProduct = await checkProductStatus(product, originalProduct);

            if (isUnauthorizedProduct) {
                isUnauthorized = true;
                return;
            }

            isCompleteChild = isCompleteChild || product._PointStoreProductOrderedDTO.ProductStatus === 4;
            isCancelledChild = isCancelledChild || product._PointStoreProductOrderedDTO.ProductStatus === 5;
        });

        if (!isUnauthorized) {
            if (isCompleteChild || isCancelledChild) {
                this.EditPointStoreProductAdminOrderManagement(order, true);
            } else {
                this.EditPointStoreProductAdminOrderManagement(order, true);
            }
        }
    }
};

  async validateChangeStatusCancelled() {
    return new Promise(async (resolve, reject) => {
      let validation = new CVVALIDATION.ValidationInstance();
      validation.succeeded = false;
      validation.addValidationError(await this.cvLocalizationService.GetLocalText("MarketPlace_Management_Messages", "Change_Status_Cancelled", "If you change the status to cancelled, you can not undo it, Continue anyway?"), true);
      showConfirmDialog("<ul class='errorBulletList'>" + validation.messagesToListItemsString() + "</ul>",
        [
          {
            text: await this.cvLocalizationService.GetLocalText("Common", "Yes", "Yes"),
            click: () => {
              let msg: any = $(".errorDialog");
              msg.dialog("close");
              resolve(true);
            }
          },
          {
            text: await this.cvLocalizationService.GetLocalText("Common", "No", "No"),
            click: () => {
              let msg: any = $(".errorDialog");
              msg.dialog("close");
              resolve(false);
            }
          }
        ], await this.cvLocalizationService.GetLocalText("MarketPlace_Management_Messages", "Order_Management_Validation_Warning", "Point Store Order Management Validation Warning"), 'warning');
    });
  }

  clickEdit(order) {
    this.pointStoreProductOrderObj.originalPointStoreProductOrder = angular.copy(order);
    this.copyOriginalToModified();
    order.clickEdited = true;
  }

  clickCancel(order) {
    this.clickClose(order);
  }

  clickOpenClose(order) {
    if (order.clickExpanded == undefined) {
      order.clickExpanded = false;
      order.clickEdited = false;
    }
    order.clickExpanded = !order.clickExpanded;
    if (!order.clickExpanded) order.clickEdited = false;
  }

  setSortListAdmin(i) {
    if (this.pointStoreProductOrderObj.pointStoreProductOrderAdminSort[i].sort == true)
      this.pointStoreProductOrderObj.sortAdminReverse = !this.pointStoreProductOrderObj.sortAdminReverse;
    else
      this.pointStoreProductOrderObj.sortAdminReverse = false;

    for (let j = 0; j < this.pointStoreProductOrderObj.pointStoreProductOrderAdminSort.length; j++) {
      this.pointStoreProductOrderObj.pointStoreProductOrderAdminSort[j].sort = null;
    }

    this.pointStoreProductOrderObj.pointStoreProductOrderAdminSort[i].sort = true;
    this.pointStoreProductOrderObj.sortAdminBy = this.pointStoreProductOrderObj.pointStoreProductOrderAdminSort[i].name;
  }

  getPointStoreProductOrderCSSSortAdmin(i) {
    var css = '';
    var setting = angular.copy(this.pointStoreProductOrderObj.settingPointStoreProductOrder)
    var settingCSS = angular.copy(this.pointStoreProductOrderObj.pointStoreProductOrdersCSS);

    if (this.pointStoreProductOrderObj.pointStoreProductOrderAdminSort[i].sort == null) css = settingCSS[12].name; //Changed from [9]
    else if (this.pointStoreProductOrderObj.pointStoreProductOrderAdminSort[i].sort == true &&
      this.pointStoreProductOrderObj.sortAdminReverse == false) css = settingCSS[13].name; //Changed from [10]
    else if (this.pointStoreProductOrderObj.pointStoreProductOrderAdminSort[i].sort == true &&
      this.pointStoreProductOrderObj.sortAdminReverse == true) css = settingCSS[14].name; //Changed from [11]

    return css;
  }

  getPointStoreProductOrderCssCoinsColor(coins) {
    return (coins >= 0) ? "green" : "red";
  };

  getPointStoreProductOrderValueCoins(coins) {
    return (coins >= 0) ? coins : "(" + coins + ")";
  };

  changeStatusOrderDetail(order) {
    let fatherStatusOrder = 5;
    for (let i = 0; i < order.ProductsCollection.length; i++) {
      if (order.ProductsCollection[i].ProductStatus < fatherStatusOrder) {
        fatherStatusOrder = order.ProductsCollection[i].ProductStatus;
      }
    }
    order.OrderStatus = fatherStatusOrder;
  };
  changeStatusOrder(order) {
    for (let i = 0; i < order.ProductsCollection.length; i++) {
      if (order.ProductsCollection[i].ProductStatus < 4) {
        order.ProductsCollection[i].ProductStatus = order.OrderStatus;
      }
    }
  };

  getDatePosition() {
    return this.pointStoreProductOrderObj.pointStoreProductAdminOrderFilter.datePosition;
  }
  copyOriginalToModified() {
    this.pointStoreProductOrderObj.modifiedPointStoreProductOrder = angular.copy(this.pointStoreProductOrderObj.originalPointStoreProductOrder);
  }

  async loadGroupSelectorMarketplaceAdmin() {
    try {
      const url = "/api/v2/marketplace/admin/group-selector";
      let response: any = await this.cvApiService.get(url);
      if (response.status_code == 200) {
        this.pointStoreProductOrderObj.groupSelectorController = response.data;
        this.pointStoreProductOrderObj.hasGroupSelector = true;
      } else {
        throw response;
      }
    } catch (error) {
      showErrorMessage("Error loading group selector: " + error.message);
    }
  }

  async loadPointStoreOrderLoginsNotification() {
    try {
      const url = "/api/v2/marketplace/admin/logins-notification";
      let response: any = await this.cvApiService.get(url);
      if (response.status_code == 200) {
        return response.data;
      } else {
        throw response;
      }
    } catch (error) {
      showErrorMessage("Error Loading Point Store Order Logins For Notifications: " + error.message);
    }
  }

  async savePointStoreOrderLoginsNotifications(loginsList) {
    try {
      const url = "/api/v2/marketplace/admin/add-logins-notification";
      let response: any = await this.cvApiService.post(url, loginsList);
      if (response.status_code == 200) {
        return response.data;
      } else {
        throw response;
      }
    } catch (error) {
      showErrorMessage("Error Saving Point Store Order Logins For Notifications: " + error.message);
    }
  }

  async buildAdminOrdersReport(params: any, isCxOne: boolean = false, showTimeZone: boolean = true) {
    try {
        const url = `/api/v2/marketplace/admin/order-history/export${isCxOne ? "-cxone" : ""}`;
        let response: any = await this.cvApiService.post(url, { ...params, showTimeZone });
        if (response.status_code == 200) {
            return response.data;
        } else {
            throw response;
        }
    } catch (error) {
        showErrorMessage("Error building admin orders report: " + error.message);
    }
}


  async loadGroupSelector(pageName: string, groupType: BaseGroupType) {
    try {
      const url = `/api/v1/group-selector/${pageName}?groupType=${groupType}`;
      let response: any = await this.cvApiService.get<GroupSelectorDTO>(url);
      if (response.status_code == 200) {
        return response.data;
      } else {
        throw response;
      }
    } catch (error) {
      showErrorMessage("Error loading group selector: " + error.message);
    }
  }

  async saveGroupSelector(pageName: string, groupType: BaseGroupType, groupSelector: GroupSelectorPostObject) {
    try {
      const url = `/api/v1/group-selector/${pageName}?groupType=${groupType}`;
      let response: any = await this.cvApiService.post<GroupSelectorDTO>(url, groupSelector);
      if (response.status_code == 200) {
        return response.data;
      } else {
        throw response;
      }
    } catch (error) {
      showErrorMessage("Error saving group selector: " + error.message);
    }
  }

  async loadMarketplaceEmpgroupState() {
    try {
      const url = "/api/v2/marketplace/admin/load-mktp-group-state";
      let response: any = await this.cvApiService.get(url);
      if (response.status_code == 200) {
        return response.data;
      } else {
        throw response;
      }
    } catch (error) {
      showErrorMessage("Error building admin orders report: " + error.message);
    }
  }

  async saveMarketplaceEmpgroupState(groupLevel: number, groupType: string, groupsIDs: string[], groups: string[][]) {
    try {
      const url = "/api/v2/marketplace/save-mktp-group-state";
      const params = {
        gLvl: groupLevel,
        gType: groupType,
        gIDs: groupsIDs,
        allGroups: groups
      }

      let response = await this.cvApiService.post(url, params);
      if (response.status_code == 200) {
        return response.data;
      }
      else {
        throw response;
      }
    } catch (error) {
      showErrorMessage("Error Saving Order Admin Empgroup State: " + error.message);
    }
  }

  async loadOrdersPlacedIn() {
    try {
      let response = await this.cvLocalizationService.GetSection('MarketPlace_Management_Filter');
      const formattedOrdersPlaceIn = this.pointStoreProductOrderObj.pointStoreProductAdminOrderFilter.dateCXOne.map((placed, index) => {
        if(index < 3) {
          const localizedName = response.get(placed.keyLocalization);
          return { ...placed, name: localizedName }
        }else {
          return placed;
        }
      });
      this.pointStoreProductOrderObj.pointStoreProductAdminOrderFilter.dateCXOne = [...formattedOrdersPlaceIn];
    } catch (error) {
      showErrorMessage(error.message);
    }
  }

  /**
   * method for filtering years with available orders
   */
  filterOrderRecordsByYear() {
    this.pointStoreProductOrderObj.pointStoreProductAdminOrderFilter.dateCXOne;
    const allYears = new Set(this.pointStoreProductOrderObj.adminOrders?.map(order => moment(order.DateOrdered).year()));
    const validYears = this.pointStoreProductOrderObj.pointStoreProductAdminOrderFilter.dateCXOne.filter((datePosition, index) => {
      if(index > 2) {
        return allYears?.has(datePosition.value);
      } else if (index < 3) {
        return true;
      }
      return false;
    });
    this.pointStoreProductOrderObj.pointStoreProductAdminOrderFilter.dateCXOne = [...validYears];
  }

  /** true when no team/agent is selected: every level still holds -2, or was emptied by Clear All. */
  isEmptyEmpGroupCXOne(): boolean {
    const empGroupCXOne = this.pointStoreProductOrderObj.pointStoreProductAdminOrderFilter.empGroupCXOne;
    if (empGroupCXOne == undefined) {
      return true;
    }
    return empGroupCXOne.slice(1).every((level) => !level?.length || parseInt(level[0]) === -2);
  }

    /**
   * 
   * @param item 
   * @returns 
   */
    setFilterMatchesEmpGroupCXOne(item) {
      let match_groupSelector = false;
      let groupLevelSelected = 0;
      let firstLevelNonZero = -1;
      let flagForFirstLevel = false;
      let GroupSelectorIDs = Array.isArray(this.pointStoreProductOrderObj.pointStoreProductAdminOrderFilter.gIDs) ? this.pointStoreProductOrderObj.pointStoreProductAdminOrderFilter.gIDs : Array.from(this.pointStoreProductOrderObj.pointStoreProductAdminOrderFilter.gIDs);
      var glvl = parseInt(this.pointStoreProductOrderObj.pointStoreProductAdminOrderFilter.gLvl)
  
      //no team/agent selected: match everything. Without this the switch falls through to case 1,
      //which only matches RelatedGroupLevel 1 and hides orders from logins above agent level.
      if (this.isEmptyEmpGroupCXOne()) {
        return true;
      }

      if (this.pointStoreProductOrderObj.pointStoreProductAdminOrderFilter.empGroupCXOne != undefined) {
        for (let i = 1; i <= this.pointStoreProductOrderObj.pointStoreProductAdminOrderFilter.empGroupCXOne.length - 1; i++) {
          if (parseInt(this.pointStoreProductOrderObj.pointStoreProductAdminOrderFilter.empGroupCXOne[i][0]) || this.pointStoreProductOrderObj.pointStoreProductAdminOrderFilter.empGroupCXOne[i][0] === "0") {
            if (parseInt(this.pointStoreProductOrderObj.pointStoreProductAdminOrderFilter.empGroupCXOne[i][0]) >= 0 && !flagForFirstLevel) {
              flagForFirstLevel = true;
              firstLevelNonZero = i;
            }
          }
        };
        for (let i = this.pointStoreProductOrderObj.pointStoreProductAdminOrderFilter.empGroupCXOne.length - 1; i > 0; i--) {
          if (this.pointStoreProductOrderObj.pointStoreProductAdminOrderFilter.empGroupCXOne[i][0] != -1)
            groupLevelSelected = i;
        }
      }
  
      //There are other filter.
      //if there was a level with a non zero value (group selected), then use that level
      var finalVariable = firstLevelNonZero != -1 ? firstLevelNonZero : groupLevelSelected;
  
      //All the filtering process for the agents will be done for the Group1ID and the LoginID because some of them will have the same ID.
      switch (finalVariable) {
        case 0:
        case 1: 
        match_groupSelector = 
        (item.RelatedGroupLevel == 1
          && 
          (
            (
              this.pointStoreProductOrderObj.pointStoreProductAdminOrderFilter.empGroupCXOne[1][0] == -2
              ||
              this.pointStoreProductOrderObj.pointStoreProductAdminOrderFilter.empGroupCXOne[1].filter(function (value) { return parseInt(value) == item.Group1ID }).length > 0
            )
            &&
            (
              this.pointStoreProductOrderObj.pointStoreProductAdminOrderFilter.empGroupCXOne[3][0] == -2
              ||
              this.pointStoreProductOrderObj.pointStoreProductAdminOrderFilter.empGroupCXOne[3].filter(function (value) { return parseInt(value) == item.LoginID }).length > 0
            )
          )
        ); 
        break;
        case 2:
          match_groupSelector =
            (
              (
                firstLevelNonZero == -1 && this.pointStoreProductOrderObj.pointStoreProductAdminOrderFilter.empGroupCXOne[2][0] == -2
              )
              || 
              this.pointStoreProductOrderObj.pointStoreProductAdminOrderFilter.empGroupCXOne[2].filter(function (value) { return parseInt(value) == item.Group2ID }).length > 0
            )
            &&
            (
              this.pointStoreProductOrderObj.pointStoreProductAdminOrderFilter.empGroupCXOne[1][0] == -2
              ||
              (
                this.pointStoreProductOrderObj.pointStoreProductAdminOrderFilter.empGroupCXOne[1].filter(function (value) { return parseInt(value) == item.Group1ID }).length > 0
              )
              || this.pointStoreProductOrderObj.pointStoreProductAdminOrderFilter.empGroupCXOne[1][0] == -1
            )
            &&
            (
              this.pointStoreProductOrderObj.pointStoreProductAdminOrderFilter.empGroupCXOne[3][0] == -2
              ||
              (
                this.pointStoreProductOrderObj.pointStoreProductAdminOrderFilter.empGroupCXOne[3].filter(function (value) { return parseInt(value) == item.LoginID }).length > 0
              )
              || this.pointStoreProductOrderObj.pointStoreProductAdminOrderFilter.empGroupCXOne[3][0] == -1
            )
            &&
            (
              (
                groupLevelSelected == 1 && item.RelatedGroupLevel == 1
              )
              ||
              groupLevelSelected == 2 && item.RelatedGroupLevel == 2
            );
          break;
      }
      return match_groupSelector;
    }
}
